<template>
    <div class="block-container">
        <div class="right-toolbar fr">
            <span class="ml10" v-if="goodsRecvReturnItemList != null && goodsRecvReturnItemList.length > 0">{{ optionFlag == 'return' ? '退' : '换' }}货商品数({{goodsRecvReturnItemList.length}})</span>
        </div>
        <el-table ref="multipleTable" :data="goodsRecvReturnItemList" border tooltip-effect="dark" style="width: 100%">
            <el-table-column align="left" prop="goodsTitle" label="商品名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="tmpNo" label="系统编号" width="240" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="vendorUkno" label="商品标识码" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="quantity" label="数量" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="theUnit" label="单位" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="batchNo" label="批次号" width="140" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import goodsDelivApi from '../../api/goodsDeliv'

    export default {
        name: 'swb-goods-recv-return-item-list-view',
        desc: '退换货商品明细预览',
        props: {
            recvVoucherId: {
                type: Number,
                default: null
            },
            recvVoucherItemId: {
                type: Number,
                default: null
            },
            optionFlag: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //
                goodsRecvReturnItemList: []
            }
        },
        created: function () {
            this.getGoodsRecvReturnItems();
        },
        methods: {
            getGoodsRecvReturnItems: function () {
                let self = this;
                let postData = {
                    recvVoucherId: self.recvVoucherId
                };
                if (!Utils.isNoB(self.recvVoucherItemId)) {
                    postData.recvVoucherItemId = self.recvVoucherItemId;
                }
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvDevcItemList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type === "info") {
                        self.goodsRecvReturnItemList = result.data || [];
                    } else {
                        self.$message.error(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsRecvReturnItemListView.vue